<script setup lang="ts">
  import { ref, watch } from "vue";
  import type { MentionItem } from "./mention-extension";

  const props = defineProps<{
    items: MentionItem[];
    // eslint-disable-next-line no-unused-vars
    command: (item: { id: string }) => void;
  }>();

  const selectedIndex = ref(0);

  watch(
    () => props.items,
    () => {
      selectedIndex.value = 0;
    },
  );

  const selectItem = (index: number): void => {
    const item = props.items[index];
    if (item) props.command({ id: item.id });
  };

  const onKeyDown = ({ event }: { event: KeyboardEvent }): boolean => {
    if (event.key === "ArrowUp") {
      selectedIndex.value = Math.max(0, selectedIndex.value - 1);
      return true;
    }
    if (event.key === "ArrowDown") {
      selectedIndex.value = Math.min(props.items.length - 1, selectedIndex.value + 1);
      return true;
    }
    if (event.key === "Enter") {
      selectItem(selectedIndex.value);
      return true;
    }
    return false;
  };

  defineExpose({ onKeyDown });
</script>

<template>
  <div
    v-if="items.length > 0"
    class="bg-popover border rounded-md shadow-lg p-1 max-h-48 overflow-auto">
    <button
      v-for="(item, index) in items"
      :key="`${item.id}-${index}`"
      type="button"
      :class="[
        'w-full text-left px-3 py-1.5 rounded text-13 flex flex-col',
        index === selectedIndex ? 'bg-accent' : 'hover:bg-muted',
      ]"
      @click="selectItem(index)">
      <span class="font-medium">{{ item.label }}</span>
      <span class="text-xs text-muted-foreground">{{ item.description }}</span>
    </button>
  </div>
</template>
